import { render, staticRenderFns } from "./purchase-recode.vue?vue&type=template&id=4026e5d0"
import script from "./purchase-recode.vue?vue&type=script&lang=js"
export * from "./purchase-recode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports